<template>
    <div id="app">
        <nav v-if="showNav" class="navbar navbar-expand-lg navbar-dark bg-primary">
            <a href="/home" class="navbar-brand">gwimyo</a>

            <!-- 햄버거 버튼 -->
            <button class="navbar-toggler"
                    type="button"
                    @click="toggleMobileMenu"
                    aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- 접히는 메뉴 영역 -->
            <div class="collapse navbar-collapse" id="navbarContent">
                <!-- 왼쪽 메뉴 -->
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item" v-if="!currentUser">
                        <router-link to="/home" class="nav-link" @click="closeMobileMenu">Home</router-link>
                    </li>
                    <li class="nav-item" v-if="showOmok">
                        <router-link to="/Omok" class="nav-link" @click="closeMobileMenu">Omok</router-link>
                    </li>
                    <li class="nav-item" v-if="showTestPage">
                        <router-link to="/TestPage" class="nav-link" @click="closeMobileMenu">TestPage</router-link>
                    </li>
                    <li class="nav-item" v-if="showMain">
                        <a class="nav-link" @click.prevent="goMain" @click="closeMobileMenu">Main</a>
                    </li>
                    <li class="nav-item" v-if="showTodolist">
                        <router-link to="/todoList" class="nav-link" @click="closeMobileMenu">TodoList</router-link>
                    </li>
                    <li class="nav-item" v-if="showAdminBoard">
                        <router-link to="/admin" class="nav-link" @click="closeMobileMenu">Admin Board</router-link>
                    </li>
                    <li class="nav-item" v-if="showModeratorBoard">
                        <router-link to="/mod" class="nav-link" @click="closeMobileMenu">Moderator Board</router-link>
                    </li>
                    <li class="nav-item" v-if="currentUser">
                        <router-link to="/user" class="nav-link" @click="closeMobileMenu">User</router-link>
                    </li>
                </ul>

                <!-- 오른쪽 메뉴 -->
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item" v-if="showSignUp">
                        <router-link to="/register" class="nav-link" @click="closeMobileMenu">
                            <font-awesome-icon icon="user-plus" /> Sign Up
                        </router-link>
                    </li>

                    <li class="nav-item" v-if="!currentUser">
                        <router-link to="/login" class="nav-link" @click="closeMobileMenu">
                            <font-awesome-icon icon="sign-in-alt" /> Login
                        </router-link>
                    </li>

                    <li class="nav-item dropdown" v-if="currentUser">
                        <router-link to="/profile" class="nav-link" @click="closeMobileMenu">
                            <font-awesome-icon icon="user" /> {{ currentUser.loginId }}
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="currentUser">
                        <a class="nav-link" @click.prevent="logOut">
                            <font-awesome-icon icon="sign-out-alt" /> LogOut
                        </a>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="container mt-3">
            <router-view />
        </div>        
    </div>
</template>


<script>
    import { defineComponent } from 'vue';
    import FilesService from "./services/files.service";
    import * as bootstrap from 'bootstrap';
    import { useRoute } from 'vue-router';

    export default defineComponent({
        data() {
            return {
                hideNavRoutes: ['share'], // 네비 숨길 라우터 이름 목록
            };
        },
        computed: {
            showNav() {
                return !this.hideNavRoutes.includes(this.$route?.name);
            },
            currentUser() {
                return this.$store.state.auth.user;
            },
            showAdminBoard() {
                if (this.currentUser && this.currentUser['roles']) {
                    return this.currentUser['roles'].includes('ROLE_ADMIN');
                }

                return false;
            },
            showModeratorBoard() {
                if (this.currentUser && this.currentUser['roles']) {
                    return this.currentUser['roles'].includes('ROLE_MODERATOR');
                }

                return false;
            },
            showTodoList() {
                if (this.currentUser && this.currentUser['roles']) {
                    return this.currentUser['roles'].includes('ROLE_ADMIN');
                }

                return false;
            },
            showMain() {
                if (this.currentUser && this.currentUser['roles']) {
                    return this.currentUser['roles'].includes('ROLE_ADMIN');
                }

                return false;
            },
            showSignUp() {
                if (this.currentUser && this.currentUser['roles']) {
                    return this.currentUser['roles'].includes('ROLE_ADMIN');
                }

                return false;
            },
            showTodolist() {
                if (this.currentUser && this.currentUser['roles']) {
                    return true;
                }

                return false;
            },
            showOmok() {
                if (this.currentUser && this.currentUser['roles']) {
                    return true;
                }

                return false;
            },
            showTestPage() {
                if (this.currentUser && this.currentUser['roles']) {
                    return true;
                }

                return false;
            }
        },
        methods: {
            logOut() {
                this.closeMobileMenu();
                this.$store.dispatch('auth/logout');
                this.$router.push('/login');
            },
            async goMain() {
                this.closeMobileMenu();                
                this.$router.push('/main');                
            },
            toggleMobileMenu() {
                const navbarCollapse = document.getElementById('navbarContent');
                if (!navbarCollapse) return;

                const collapseInstance =
                    bootstrap.Collapse.getInstance(navbarCollapse) ||
                    new bootstrap.Collapse(navbarCollapse, { toggle: false });

                navbarCollapse.classList.contains('show')
                    ? collapseInstance.hide()
                    : collapseInstance.show();
            },
            closeMobileMenu() {
                const navbarCollapse = document.getElementById('navbarContent');
                if (navbarCollapse && navbarCollapse.classList.contains('show')) {
                    const collapseInstance =
                        bootstrap.Collapse.getInstance(navbarCollapse) ||
                        new bootstrap.Collapse(navbarCollapse, { toggle: false });
                    collapseInstance.hide();
                }
            },
        }
    });
</script>

<style scoped>
    .right-tab {
        float: right;
    }
</style>